import LoginLayout from '@/layouts/login/index.vue';
import LoginComponent from "@/modules/login/pages/index.vue";

import AdminRoutes from "@/routes/paths/admin.js";

export default [
  {
    path: '/',
    component: LoginLayout,
    children: [
      {
        path: '',
        component: LoginComponent,
        name: 'login',
      },
      {
        path: 'login',
        component: LoginComponent,
        name: 'login',
      },
    ]
  },
  ...AdminRoutes,
];

